import type React from 'react'

import type { SvgIconProps } from '~/@mid_ui/icons/svgIcon'
import { ProfileIcon } from '~/@mid_ui/icons/ProfileIcon'
import { KeyIcon } from '~/@mid_ui/icons/KeyIcon'
import type { UserWithMeta } from '~/@biz_account/useUser/types'
import { IdCardIcon } from '~/@mid_ui/icons/IdCardIcon'
import { AffiliateIcon } from '~/@mid_ui/icons/AffiliateIcon'
import { SecurityIcon } from '~/@mid_ui/icons/SecurityIcon'
import { NotificationIcon } from '~/@mid_ui/icons/NotificationIcon'
import { AmbassadorIcon } from '~/@mid_ui/icons/AmbassadorIcon'

type MenuItem = {
  Icon: React.ComponentType<SvgIconProps>
  label: string
  route: string
  isVisible?(user: UserWithMeta): boolean
}

export const menuItems: MenuItem[] = [
  {
    Icon: ProfileIcon,
    label: 'Môj profil',
    route: '/settings/profile',
  },
  {
    Icon: KeyIcon,
    isVisible: (user) => user.meta.hasPassword,
    label: 'Nové heslo',
    route: '/settings/password',
  },
  {
    Icon: IdCardIcon,
    label: 'Informácie o účte',
    route: '/settings/bank-accounts',
  },
  {
    Icon: AffiliateIcon,
    label: 'Affiliate',
    route: '/settings/affiliate',
  },
  {
    Icon: AmbassadorIcon,
    isVisible: (user) => !user.profile.ambassador,
    label: 'Môj ambasádor',
    route: '/settings/my-ambassador',
  },
  {
    Icon: AmbassadorIcon,
    isVisible: (user) => !!user.profile.ambassador,
    label: 'Ambasador',
    route: '/settings/ambassador',
  },
  {
    Icon: SecurityIcon,
    isVisible: (user) => user.meta.authType === 'email',
    label: 'Bezpečnosť',
    route: '/settings/security',
  },
  {
    Icon: NotificationIcon,
    label: 'Notifikácie',
    route: '/settings/notifications',
  },
]
